<template>
	<div>
		<div v-if="this.$store.state.alert_success" class="alert alert-success alert-dismissible">
			<button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
			<h4>
				<i class="icon fa fa-check"></i> Sucesso! </h4>
				{{ $store.state.alert_message != '' ? $store.state.alert_message : 'Operação realizada com sucesso!' }}
		</div>
		<div v-if="this.$store.state.alert_error" class="alert alert-danger alert-dismissible">
			<button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
			<h4>
				<i class="icon fa fa-ban"></i> Erro! </h4>
				{{ $store.state.alert_message != '' ? $store.state.alert_message : 'Ocorreu um erro ao realizar a operação!' }}
		</div>
	</div>
</template>

<script>
export default {
}
</script>

<style>
.blink_me {
  animation: blinker 0.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Alert.vue?ec22966a